import * as THREE from "three";

export class Renderer {
  constructor(store) {
    this.store = store;
    this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: false, precision: "highp",});
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    document.getElementById("app").appendChild(this.renderer.domElement);
    this.store.config.isMobile = this.detectMobile();
  }

  render(scene, camera) {this.renderer.render(scene, camera);}

  handleResize(camera) {
    window.addEventListener("resize", () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.store.config.isMobile = this.detectMobile();
    });
  }

  detectMobile() {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    const isSmall = window.innerWidth <= 1200;
    this.store.config.isTouch = isTouch;
    this.store.config.isSmall = isSmall;
    return isTouch && isSmall;
  }
}